module.exports = __webpack_public_path__ + "static/media/poster_howto.aaa09936.png";